import React from "react"
import { remark } from 'remark'
import markdown from 'remark-parse'
import gfm from 'remark-gfm'
import slug from 'remark-slug'
import toc from 'remark-toc'
import remark2rehype from 'remark-rehype'
import rehype2react from 'rehype-react'
import raw from 'rehype-raw'

import BasicLink from "~/components/Link"

const processor = remark()
  .use(markdown)
  .use(gfm)
  .use(slug)
  .use(toc, { tight: true })
  .use(remark2rehype, { allowDangerousHtml: true })
  .use(raw) // allows html (UNSANITIZED BE CAREFUL DO NOT ALLOW USER INPUT)
  .use(rehype2react, {
    createElement: React.createElement,
    components: {
      a: BasicLink
    }
  })


const MarkdownComponent = ({src}) => {
  return processor.processSync(src).result
}

export default MarkdownComponent
